<template>
	<a @click="e => $emit('click',e)" v-if="href" :href="href" class="btn" :class="{'btn-block' : block, ['btn-' + size] : size, ['btn-' + color] : color}"><slot></slot></a>
	<button @click="e => $emit('click',e)" v-else class="btn" :class="{'btn-block' : block, ['btn-' + size] : size, ['btn-' + color] : color}"><slot></slot></button>
</template>

<script>
  export default {

    name: 'btn',

    props:{
      block: { type: Boolean, required: false, default: false },
      color: { type: String, required: false, default: null },
      size: { type: String, required: false, default: null },
      href : { type: String, required: false, default: null }
    }
  }
</script>